export default __webpack_public_path__ + "static/media/red-error.87d788bc.svg";